export default {
  navTitle:'Inspiration Path',
  levelNowCondition: '{expValue} Exp to next level',
  benefitsTitle: 'Benefits',
  benefitsMore: 'Learn more',
  theme:'Theme',
  themeMore:'Customize',
  appStartUpImg:'Splash Screen',
  avatarWidget:'Avatar Frame',
  homePageCover:'Profile Background',
  benefitsDetailTitle: 'Benefits',
  nextLevel: '{value} Growth Points to the next level.',
  creatorNextLevel: '{value} Creator Points to the next level.',
  upperLevel: `You haven't reached this level yet.`,
  currentLevel: 'This level is already unlocked.',
  maxLevel: 'You’ve unlocked the highest level available.',
  upgradeNow: 'Check Tasks',
  draw: 'Join now',
  getMedal: 'Claim',
  sideSuitup:'Apply All',
  sideSuitoff: 'Remove All',
  suitup: 'Apply selected',
  suitoff: 'Remove selected',
  greeting: 'Daily Check-in',
  checkin: 'Check in',
  checked: 'Done',
  today: 'Today',
  checkinaccumulated: 'So far, you have checked in {n} day in a row. | So far, you have checked in {n} day in a row. | So far, you have checked in {n} days in a row.',
  unlockRule: 'This theme is locked until you reach the {name} level.',
  restore: 'Restore',
  unlock: 'Unlock',
  detail: 'Detail',
  taskTitle: 'Growth Tasks',
  taskMore: 'Points History',
  completed: 'Done',
  completeIt: 'Go',
  locked: 'Locked',
  endLocked: 'Locked',
  bestPick: 'Best Picks',
  bestTopic: 'Hot Topics',
  playRules: 'Introduction',
  growValueDetail: 'Points History',
  experienceDetails: 'Growth Points History',
  browseAwards:'Browse {time}s get awards',
  completedAwards:'Task Completed',
  checkIt: 'Check it',
  discover: 'Discover',
  noRecord:'No record',
  decorationBenefits:' Level up and unlock privileges',

  // 权益弹框标题和内容
  popupMeetupTitle:'Meetup Access',
  popupMeetupContent:'Congratulations! You have unlocked the opportunity to participate in our OPPO Meetup events.\n\n Starting at Level 3, each upgrade increases your chances of being invited to one of our Meetups.',
  popupAmbassadorTitle:'Ambassador Path',
  popupAmbassadorContent:'Congratulations! You’ve unlocked the opportunity to become an OPPO Product Ambassador!\n\nStarting at Level 3, each upgrade increases your chances of being selected as an ambassador for one of our products.',


  // 普通会员权益页说明
  mDecorationsIntro:`A theme set includes an avatar decoration, splash page, and profile background. Each level has a different regular theme set, as well as a limited-time set. You can choose which elements of a set you which to apply. Limited-time sets are gone once the time is up, so don't miss them!`,
  mPrizeIntro:'Exciting prizes await members at every level! The higher your level, the greater your chances of winning and the bigger the rewards.\n\nOur prize pool features incredible products, including the OPPO Reno Series, earbuds, and an array of exclusive merchandise.\n\nEach level-up brings you closer to winning, so don’t miss your chance to claim these amazing rewards!',
  mMedalIntro:'We’ve designed exclusive badges for every level in our Milestones system! Each time you level up, you’ll unlock a new badge that you can proudly display on your profile page. These badges are a special way to celebrate and showcase your journey and growth in the OPPO Community. ',
  mMeetUpIntro:'Starting at Level 3, you’ll have the opportunity to participate in OPPO Meetup events! As your level increases, so do your chances of being invited to one of our exclusive OPPO Meetups.\n\nDuring these events, you’ll join fellow members for offline activities and unforgettable adventures, and get a chance to experience our latest merchandise and products firsthand.',

  // 创作者权益页说明
  medalIntro: 'We’ve designed exclusive badges for every level in our Inspiration Path! These badges are a completely unique series for OPPO Community Content Creators. You can wear both Milestoes and Creators badges at the same time. After each upgrade, you will receive a new badge.',
  exposureIntro:'Great content deserves the spotlight! As you level up in the Inspiration Path, your content gets an exposure boost, increasing the visibility of all the content you create.',
  ambassadorIntro:`Starting at Level 3, you unlock your Ambassador Path. Each upgrade increases your chances of being selected as an Ambassador for one of our products.\n\nAs an Ambassador, you will get the chance to experience OPPO's new devices in advance and to be invited to some of our offline activities.`,

  // 规则说明标题
  ruleIntroTitle:'What are Growth Points?',

  // 普通会员规则
  milestoneRuleFirstTitle:'What are Growth Points?',
  milestoneRuleFirstText:'Growth Points reflect your participation in the OPPO Community and help you unlock new Milestone Levels. Each new level brings exclusive perks closer to your reach.',
  milestoneRuleSecondTitle:'How to earn Growth Points?',
  milestoneRuleSecondText:`Earn Growth Points by actively engaging in the OPPO Community. Here are a few examples of how you can collect Points:</br></br>
  <li>Register a Community Account</li>
  <li>Change Your Avatar</li>
  <li>Change Your Username</li>
  <li>Edit Your Community Bio</li>
  <li>Join at least 3 Circles</li>
  <li>Check-in Regularly</li>
  <li>Follow 20 Community Members</li>
  <li>Participate in Community Polls</li>
  <li>Comment on Threads (minimum 20 characters)</li>
  <li>Report Spam Threads Effectively</li>
  <li>Post a thread (Articles: 500+ Characters; Moments: 250+ Characters)</li>
  <li>Have Your Content Featured as a Best Pick</li>
  <li>Browse and Explore Threads</li>
  <li>Like Threads</li>
  `,

  // 创作者规则
  creatorRuleFirstTitle:'What are Creator Points?',
  creatorRuleFirstText:'Creator Points are the foundation of a system designed to recognize outstanding creators and creations in the OPPO Community. Unlocking new levels brings you closer to exclusive perks and opportunities.',
  creatorRuleSecondTitle:'How to earn Creator Points?',
  creatorRuleSecondText:`You can earn Creator Points by creating and sharing high-quality content with the OPPO Community. Here are a few ways to gain them:</br></br>
  <li>Accumulate 10/30/80 Likes on Your threads</li>
  <li>Receive 5/10/30 Replies on Your Threads</li>
  <li>Gather 10/100/300 Views on Your Threads</li>
  <li>Publish a Total of 1/5/10 Threads</li>
  <li>Reach 10/30/50 Followers</li>
  <li>Earn 1/3/5 Best Picks Labels on Your Content</li>
  <li>Post Threads (Articles: 500+ characters; Moments: 250+ characters)</li>
  <li>Have Your Threads Labeled as Best Picks</li>`,

  checkinTitle: 'Check in introduction',

  checkinFirstTitle: 'Check-in Conditions: ',
  checkinFirstText: 'You must be logged in to check in and you can only do it one time daily.',
  checkinSecondTitle: 'Check-in Time: ',
  checkinSecondText: 'The check-in time zone corresponds to the country you selected during OPPO account registration and will not adjust based on your current location.',
  checkinThirdTitle: 'Check-in Method: ',
  checkinThirdText: 'Check-in via the Community App’s home page or the Milestones menu. Both methods are synchronized and function the same way.',
  checkinForthTitle: 'Check-in Rewards:',
  checkinForthText: 'You can earn 1 Growth Point for checking in daily. After 7 consecutive days of Check-ins, you’ll receive 1 additional Growth Point. Once you reach 7 consecutive Check-ins, the count will reset to 0.',
};
